import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest } from 'rxjs/internal/observable/combineLatest';
import { map } from 'rxjs/operators';
import { DateDifferenceService } from 'src/app/shared/display/date-difference.service';

@Pipe({
  name: 'dateDifference'
})
export class DateDifferencePipe implements PipeTransform {
  private isBold: boolean;

  constructor(
    private translate: TranslateService,
    private dateDifferenceService: DateDifferenceService,
  ) {}

  /**
   * example 1: {{ data.birthday | dateDifference | async }}
   * return 'Age 25 Years 10 Months 19 Days'
   * example 2: {{ data.birthday | dateDifference:'obj':true | async }}
   * return 'Age <b>25</b> Years <b>10</b> Months <b>19</b> Days'
   */
  transform(value: any, type: 'date' | 'obj' = 'date', isBold?: boolean, isQuickQuotek?: boolean): any {
    if (!value) {
      return '';
    }

    this.isBold = isBold;
    return combineLatest(
      this.translate.get('personal.age'),
      this.translate.get('calendar.year'),
      this.translate.get('calendar.month'),
      this.translate.get('calendar.day'),
    ).pipe(
      map(([_age, _year, _month, _day]) => {
        // combineLatest returns an array of values, here we map those values to an object
        const { years, months, days } = this.dateDifferenceService.diffCurrentDate(value, type, isQuickQuotek);
        return `${_age} ${this.cb(years)} ${this.cm(years, _year)}` + ' '
          + `${this.cb(months)} ${this.cm(months, _month)} ${this.cb(days)} ${this.cm(days, _day)}`;
      })
    );
  }

  /**
   * check value more one, append 's'
   */
  private cm(val: number, key: string): string {
    return this.translate.currentLang === 'en' && val > 1 ? `${key}s` : key;
  }

  private cb(val: number): string | number {
    return this.isBold ? `<b>&nbsp;${val}&nbsp;</b>` : val;
  }

}
